export const imageExperienceLegacyStrings = {
  ImageExperience_RemoveAllImages: _TL_('I don\'t want to display images in my ads'),
  Entity_Ads: _TL_('Ad'),
};
